import {PlaceCannonAction} from 'src/Action';
import {Game} from '../Game';
import {cannonRenderer} from 'src/Pixi/map/CannonRenderer';
import {Loc} from 'src/common/map/Location';
import Connection from 'src/Connection';

export class PlaceCannon {
    public constructor(private game: Game) {
        // Sets instance variables
    }

    public byServer({x, y}: PlaceCannonAction): void {
        const cannon = this.game.map.cannons.find(cannon => cannon.x === x && cannon.y === y);
        const owner = this.game.map.heldBy[y][x];
        if (!cannon) {
            this.game.map.placeCannon(owner, x, y);
            cannonRenderer.createCannon({x, y, owner});
        }
        const spawnsHeld = this.game.map.countHeldSpawns();
        const spawnCount = spawnsHeld.get(owner) || 0;
        const cannonsCanPlace = spawnCount + 1;
        const player = this.game.players[owner];
        const cannonsPlacedThisRound = this.cannonCount(owner) - player.cannonsPlacedBefore;
        player.cannonsLeftToPlace = cannonsCanPlace - cannonsPlacedThisRound;
    }

    public byClient({x, y}: Loc): void {
        const owner = this.game.index;
        Connection.send('place', {x, y});
        this.game.map.placeCannon(owner, x, y);
        this.game.currentPlayer.cannonsLeftToPlace -= 1;
        cannonRenderer.createCannon({x, y, owner});
    }

    private cannonCount(owner: number): number {
        return this.game.map.cannons.filter(cannon => cannon.owner === owner).length;
    }
}



// WEBPACK FOOTER //
// ./src/game/actions/PlaceCannon.ts